import { render } from "./TabsSection.html?vue&type=template&id=4912e71f&scoped=true&ts=true"
import script from "./TabsSection.ts?vue&type=script&lang=ts"
export * from "./TabsSection.ts?vue&type=script&lang=ts"

import "./TabsSection.scss?vue&type=style&index=0&id=4912e71f&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4912e71f"]])

export default __exports__